/** An organization root is a placeholder, never a conversation's file store. */
export function resolveFileWorkspaceRoot(
  worktreePath: string | null | undefined,
  projectRoot: string | null | undefined,
): string | null {
  if (worktreePath) return worktreePath;
  if (!projectRoot || /(?:^|[/\\])amoreg-workspaces[/\\]/.test(projectRoot)) return null;
  return projectRoot;
}
